export default __webpack_public_path__ + "0b4a0eed7e875fd5096a53113085eaf4.svg";